import React, { Component } from 'react'
import { connect } from 'react-redux'

import { omit } from 'ramda'

import LawyerChatAction from '@app/modules/Messages/store/actions'

const chatDocumentHOC = (WrappedComponent) => {
  class Documents extends Component {
    render() {
      const { onUploadDocAction } = this.props
      return (
        <WrappedComponent
          onUploadDoc={({ formData, letter }) => onUploadDocAction(formData, false, letter)}
          sendData={this.sendData}
          selectedDocuments={this.props.answerWithoutReport.selectedDocuments}
          selectedLetterId={this.props.answerWithoutReport.selectedLetterId}
          {...this.props}
        />
      )
    }
  }

  return connect(({ lawyerChat }) => ({ ...omit(['customer'], lawyerChat) }), {
    onSelectedDocRemove: LawyerChatAction.onSelectedDocRemove,
    onLetterSelectedDocRemove: LawyerChatAction.onRemoveSelectedLetter,
    onUploadDocAction: LawyerChatAction.onUploadDoc
  })(Documents)
}

export default chatDocumentHOC
